import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { isRoamingLimitInfoVisible } from "../../store/banners/banners.selectors";
import { hideRoamingLimitInfo } from "../../store/banners/banners.actions";
import { isRoamingLimitReached } from "../../store/devices/logicalDevices";
import { BannerInline } from "../bannerInline/BannerInline";

import "./RoamingLimitReachedWarning.scss";

export const RoamingLimitReachedWarning = () => {
  const isPanelVisible = useSelector(isRoamingLimitInfoVisible);
  const isLimitReached = useSelector(isRoamingLimitReached);
  const dispatch = useDispatch();

  if (!isPanelVisible || !isLimitReached) return null;

  return (
    <BannerInline
      onClick={() => dispatch(hideRoamingLimitInfo())}
      message={<FormattedMessage id="roaming_reached_limit_info" />}
      className={"roaming-limit-reached-warning"}
    />
  );
};
